import alphabetic from './alphabetic';
import alphanumeric from './alphanumeric';
import currency from './currency';
import email from './email';
import name from './name';
import numeric from './numeric';
import url from './url';
import year from './year';
export default {
  alphabetic: alphabetic,
  alphanumeric: alphanumeric,
  currency: currency,
  email: email,
  name: name,
  numeric: numeric,
  url: url,
  year: year
};